const PANEL_DURATION = 450;
const CONTENT_DURATION = 250;
const IMAGE_DURATION = 750;

const initHeader = () => {
  const navToggle = document.querySelector('[data-nav-toggle]');
  const navMenu = document.querySelector('[data-nav-menu]');

  if (!navToggle || !navMenu) {
    return;
  }

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isTouchNav = window.matchMedia('(hover: none), (pointer: coarse)').matches;
  const panelDuration = prefersReducedMotion ? 0 : PANEL_DURATION;
  const contentDuration = prefersReducedMotion ? 0 : CONTENT_DURATION;
  const imageDuration = prefersReducedMotion ? 0 : IMAGE_DURATION;
  let animationTimer;
  let imageTimer;

  const clearNavImagePreview = () => {
    window.clearTimeout(imageTimer);
    navMenu.classList.remove('c-header-nav--image-active');
    navMenu.querySelectorAll('.c-header-nav__item--active').forEach((item) => {
      item.classList.remove('c-header-nav__item--active');
    });
  };

  const setAria = (isOpen) => {
    navToggle.setAttribute('aria-expanded', String(isOpen));
    navToggle.setAttribute('aria-label', isOpen ? 'Close navigation menu' : 'Open navigation menu');
    navMenu.setAttribute('aria-hidden', String(!isOpen));
  };

  const openNav = () => {
    window.clearTimeout(animationTimer);
    clearNavImagePreview();
    document.body.classList.add('has-header-nav-open');
    navToggle.classList.add('c-header__nav-toggle--open');
    navMenu.classList.add('c-header-nav--open');
    navMenu.classList.remove('c-header-nav--content-visible');
    setAria(true);

    animationTimer = window.setTimeout(() => {
      navMenu.classList.add('c-header-nav--content-visible');
    }, panelDuration);
  };

  const closeNav = () => {
    window.clearTimeout(animationTimer);
    clearNavImagePreview();
    navToggle.classList.remove('c-header__nav-toggle--open');
    navMenu.classList.remove('c-header-nav--content-visible');
    setAria(false);

    animationTimer = window.setTimeout(() => {
      document.body.classList.remove('has-header-nav-open');
      navMenu.classList.remove('c-header-nav--open');
    }, contentDuration);
  };

  navToggle.addEventListener('click', () => {
    const isOpen = navToggle.getAttribute('aria-expanded') === 'true';

    if (isOpen) {
      closeNav();
      return;
    }

    openNav();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || navToggle.getAttribute('aria-expanded') !== 'true') {
      return;
    }

    closeNav();
    navToggle.focus({ preventScroll: true });
  });

  if (isTouchNav) {
    navMenu.querySelectorAll('.c-header-nav__item--has-image .c-header-nav__link').forEach((link) => {
      link.addEventListener('click', (event) => {
        const href = link.getAttribute('href');

        if (!href) {
          return;
        }

        event.preventDefault();
        clearNavImagePreview();

        const item = link.closest('.c-header-nav__item--has-image');

        if (!item) {
          return;
        }

        item.classList.add('c-header-nav__item--active');
        navMenu.classList.add('c-header-nav--image-active');

        imageTimer = window.setTimeout(() => {
          const target = link.getAttribute('target');

          if (target === '_blank') {
            window.open(href, '_blank', 'noopener,noreferrer');
            clearNavImagePreview();
            return;
          }

          window.location.assign(href);
        }, imageDuration);
      });
    });
  }
};

export default initHeader;
